import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import ProjectsList from "./pages/ProjectsList";
import ProjectDetail from "./pages/ProjectDetail";
import Estimate from "./pages/Estimate";
import EstimateNew from "./pages/EstimateNew";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import BidComparison from "./pages/BidComparison";
import Notifications from "./pages/Notifications";
import ReceiptCapture from "./pages/ReceiptCapture";
import ReceiptProcessing from "./pages/ReceiptProcessing";
import Profile from "./pages/Profile";
import ReceiptsList from "./pages/ReceiptsList";
import ReceiptDetail from "./pages/ReceiptDetail";
import SchedulingPage from "./pages/Scheduling";
import TaskList from "./pages/Tasks";
import PicturesPage from "./pages/Pictures";
import Contacts from "./pages/Contact";
import InsertRandomTodosPage from "./pages/TodoInsert";
import Gallery from "./pages/Gallery";
import CameraTest2 from "./pages/CameraTest2";
import DesignReplica from "./pages/DesignReplica";
import CrmNew from "./pages/CrmNew";
import CostCatalog from "./pages/CostCatalog";
import ProposalsList from "./pages/ProposalsList";
import CreateProposal from "./pages/CreateProposal";
import EditProposal from "./pages/EditProposal";
import PublicProposal from "./pages/PublicProposal";
import { Toaster } from "./components/ui/sonner";

// Wrap the entire app in Notification Permission
function NotificationPermission() {
  useEffect(() => {
    if ("Notification" in window) {
      Notification.requestPermission().then((status) => {
        console.log("Notification permission status:", status);
      });
    }
  }, []);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <NotificationPermission />
      <Toaster position="top-center" richColors closeButton />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        <Route
          path="/ProjectList"
          element={
            <ProtectedRoute>
              <ProjectsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Bid-Comparison"
          element={
            <ProtectedRoute>
              <BidComparison />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:id"
          element={
            <ProtectedRoute>
              <ProjectDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Estimate"
          element={
            <ProtectedRoute>
              <Estimate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/estimate-new"
          element={
            <ProtectedRoute>
              <EstimateNew />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Receipt-Capture"
          element={
            <ProtectedRoute>
              <ReceiptCapture />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Receipt-Processing"
          element={
            <ProtectedRoute>
              <ReceiptProcessing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Receipts"
          element={
            <ProtectedRoute>
              <ReceiptsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/receipts/:id"
          element={
            <ProtectedRoute>
              <ReceiptDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Scheduling"
          element={
            <ProtectedRoute>
              <SchedulingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Tasks"
          element={
            <ProtectedRoute>
              <TaskList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Pictures"
          element={
            <ProtectedRoute>
              <PicturesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contacts"
          element={
            <ProtectedRoute>
              <Contacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Insert"
          element={
            <ProtectedRoute>
              <InsertRandomTodosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gallery"
          element={
            <ProtectedRoute>
              <Gallery />
            </ProtectedRoute>
          }
        />
        <Route
          path="/camera-test-2"
          element={
            <ProtectedRoute>
              <CameraTest2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DesignReplica"
          element={
            <ProtectedRoute>
              <DesignReplica />
            </ProtectedRoute>
          }
        />
        <Route
          path="/crm-new"
          element={
            <ProtectedRoute>
              <CrmNew />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cost-catalog"
          element={
            <ProtectedRoute>
              <CostCatalog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/proposals"
          element={
            <ProtectedRoute>
              <ProposalsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/proposals/create"
          element={
            <ProtectedRoute>
              <CreateProposal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/proposals/edit/:proposalId"
          element={
            <ProtectedRoute>
              <EditProposal />
            </ProtectedRoute>
          }
        />
        {/* Public route for viewing shared proposals */}
        <Route path="/p/:shareToken" element={<PublicProposal />} />
      </Routes>
    </BrowserRouter>
  );
}
